import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { useDialog } from '@ts-core/components/Dialog';

import { PracticeSession } from '../../types';
import { usePracticeSessionForm } from '../PracticeSessionForm';
import { CreatePracticeSessionDialogProps } from './CreatePracticeSessionDialog';

export interface CreatePracticeSessionDialogHookInput {}

export interface CreatePracticeSessionDialogHookPayload {
  dialogProps: CreatePracticeSessionDialogProps;
  onOpenCreatePracticeSessionDialog: () => void;
  onCloseCreatePracticeSessionDialog: () => void;
}

export const useCreatePracticeSessionDialog = (): CreatePracticeSessionDialogHookPayload => {
  const { courseId } = useParams<{ courseId: string }>();
  const { dialogProps, onOpenDialog, onCloseDialog } = useDialog();
  const history = useHistory();

  const handlePracticeSessionFormCreated = useCallback(
    (practiceSession: PracticeSession) => {
      onCloseDialog();
      history.push(`/${courseId}/practice/${practiceSession._id}/do`);
    },
    [history, courseId, onCloseDialog]
  );

  const { formProps } = usePracticeSessionForm({ onSuccess: handlePracticeSessionFormCreated, courseId });

  return {
    dialogProps: {
      dialogProps,
      practiceSessionFormProps: formProps,
    },
    onOpenCreatePracticeSessionDialog: onOpenDialog,
    onCloseCreatePracticeSessionDialog: onCloseDialog,
  };
};
